var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 637.546,
    height: 1179.807,
    viewBox: "455.307 304 159.387 294.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.307 304h159.386v294.952H455.307V304z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 795"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 624",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472 393h35.542v47.802H472V393z",
    fill: "#58fffa",
    "data-name": "\\u9577\\u65B9\\u5F62 364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 540h35.542v47.802H472V540z",
    fill: "#58fffa",
    "data-name": "\\u9577\\u65B9\\u5F62 366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 540h35.542v47.802H562V540z",
    fill: "#ff9dff",
    "data-name": "\\u9577\\u65B9\\u5F62 499"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 625",
    fill: "#9e9e9e",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.55 311.03h69.553v71.702H462.55V311.03z",
    "data-name": "\\u9577\\u65B9\\u5F62 368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.897 311.03h69.552v71.702h-69.552V311.03z",
    "data-name": "\\u9577\\u65B9\\u5F62 369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.55 458.857h69.553v71.703H462.55v-71.703z",
    "data-name": "\\u9577\\u65B9\\u5F62 370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.897 458.857h69.552v71.703h-69.552v-71.703z",
    "data-name": "\\u9577\\u65B9\\u5F62 371"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 634"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 629"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.83 324.496a8.166 8.166 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.623 330.854h4.833v9.666h-4.833v-9.666z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.932 337.024h2.148v7.077h-2.148v-7.077z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.182 334.223h5.715v1.464h-5.715v-1.464z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.182 339.477h5.715v1.463h-5.715v-1.463z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 375"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.116 356.02s-3.8-4.686-3.8-6.894c0-2.1 2.62-6.904 2.62-6.904l1.825-1.076.54 1.75-1.017.528s-2.468 4.128-2.468 5.744c0 1.536 3.332 6.243 3.332 6.243l-1.032.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 167"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 627"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.48 356.02s3.799-4.686 3.799-6.894c0-2.1-2.62-6.904-2.62-6.904l-1.824-1.076-.541 1.75 1.018.528s2.468 4.128 2.468 5.744c0 1.536-3.332 6.243-3.332 6.243l1.032.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 168"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.688 324.496a5.308 5.308 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.688 324.496a5.308 5.308 0 110 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 628"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.516 337.141l-1.135 5.263 2.996 1.088h3.325l2.996-1.088-1.135-5.263h-7.047z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    stroke: "#040000",
    fill: "transparent",
    "data-name": "\\u30D1\\u30B9 169"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.824 355.552l.48-6.101-.004-6.554 1.337-.002.004 6.556.49 6.1-1.092.726-1.215-.725z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 170"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.234 324.496a8.166 8.166 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.027 330.854h4.833v9.666h-4.833v-9.666z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.337 337.024h2.147v7.077h-2.147v-7.077z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.587 334.223h5.714v1.464h-5.714v-1.464z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.587 339.477h5.714v1.463h-5.714v-1.463z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 379"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 630"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.52 356.02s-3.798-4.686-3.798-6.894c0-2.1 2.618-6.904 2.618-6.904l1.825-1.076.542 1.75-1.02.528s-2.467 4.128-2.467 5.744c0 1.536 3.332 6.243 3.332 6.243l-1.031.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 171"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.884 356.02s3.799-4.686 3.799-6.894c0-2.1-2.62-6.904-2.62-6.904l-1.824-1.076-.541 1.75 1.019.528s2.467 4.128 2.467 5.744c0 1.536-3.331 6.243-3.331 6.243l1.03.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 172"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.092 324.496a5.308 5.308 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.092 324.496a5.308 5.308 0 110 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 632"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.92 337.141l-1.134 5.263 2.995 1.088h3.325l2.996-1.088-1.135-5.263h-7.046z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    stroke: "#040000",
    fill: "transparent",
    "data-name": "\\u30D1\\u30B9 173"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.228 355.552l.48-6.101-.004-6.554 1.338-.002.003 6.556.491 6.1-1.092.726-1.216-.725z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 174"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 643"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 638"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.83 474.229a8.166 8.166 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.623 480.586h4.833v9.667h-4.833v-9.667z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.932 486.757h2.148v7.077h-2.148v-7.077z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.182 483.956h5.715v1.463h-5.715v-1.463z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.182 489.21h5.715v1.463h-5.715v-1.464z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 383"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.116 505.754s-3.8-4.687-3.8-6.895c0-2.1 2.62-6.904 2.62-6.904l1.825-1.076.54 1.75-1.017.528s-2.468 4.128-2.468 5.743c0 1.537 3.332 6.244 3.332 6.244l-1.032.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 175"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 636"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.48 505.754s3.799-4.687 3.799-6.895c0-2.1-2.62-6.904-2.62-6.904l-1.824-1.076-.541 1.75 1.018.528s2.468 4.128 2.468 5.743c0 1.537-3.332 6.244-3.332 6.244l1.032.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 176"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.688 474.229a5.308 5.308 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.688 474.229a5.308 5.308 0 110 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 637"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.516 486.874l-1.135 5.262 2.996 1.089h3.325l2.996-1.089-1.135-5.262h-7.047z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    stroke: "#040000",
    fill: "transparent",
    "data-name": "\\u30D1\\u30B9 177"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.824 505.284l.48-6.1-.004-6.554 1.337-.002.004 6.555.49 6.1-1.092.726-1.215-.725z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 178"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.234 474.229a8.166 8.166 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.027 480.586h4.833v9.667h-4.833v-9.667z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.337 486.757h2.147v7.077h-2.147v-7.077z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.587 483.956h5.714v1.463h-5.714v-1.463z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.587 489.21h5.714v1.463h-5.714v-1.464z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 387"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 639"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.52 505.754s-3.798-4.687-3.798-6.895c0-2.1 2.618-6.904 2.618-6.904l1.825-1.076.542 1.75-1.02.528s-2.467 4.128-2.467 5.743c0 1.537 3.332 6.244 3.332 6.244l-1.031.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 179"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.884 505.754s3.799-4.687 3.799-6.895c0-2.1-2.62-6.904-2.62-6.904l-1.824-1.076-.541 1.75 1.019.528s2.467 4.128 2.467 5.743c0 1.537-3.331 6.244-3.331 6.244l1.03.61z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 180"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u6955\\u5186\\u5F62 42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.092 474.229a5.308 5.308 0 110 .1z",
    fill: "#040000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.092 474.229a5.308 5.308 0 110 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    stroke: "#fff",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 641"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.92 486.874l-1.134 5.262 2.995 1.089h3.325l2.996-1.089-1.135-5.262h-7.046z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.604,
    stroke: "#040000",
    fill: "transparent",
    "data-name": "\\u30D1\\u30B9 181"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.228 505.284l.48-6.1-.004-6.554 1.338-.002.003 6.555.491 6.1-1.092.726-1.216-.725z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 182"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 644",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.46 308.92h2.35v286.11h-2.35V308.92z",
    fill: "#58fffa",
    "data-name": "\\u9577\\u65B9\\u5F62 388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.189 308.92h2.35v286.11h-2.35V308.92z",
    fill: "#ff9dff",
    "data-name": "\\u9577\\u65B9\\u5F62 389"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M461.125 306.996H535v2.084h-73.875v-2.084z",
    fill: "#58fffa",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.125 452.934H535v2.084h-73.875v-2.084z",
    fill: "#58fffa",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 393h35.542v47.802H562V393z",
    fill: "#ff9dff",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 306.996h73.875v2.084H535v-2.084z",
    fill: "#ff9dff",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 452.934h73.875v2.084H535v-2.084z",
    fill: "#ff9dff",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 797"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiMachine);
export default __webpack_public_path__ + "static/media/multiMachine.b6d3ce4e116e50bc.svg";
export { ForwardRef as ReactComponent };